/* ATV — Recherche prédictive */
(function () {
  'use strict';

  const overlay = document.querySelector('[data-atv-search-overlay]');
  const input = document.querySelector('[data-atv-search-input]');
  const resultsBox = document.querySelector('[data-atv-search-results]');
  const closeBtn = document.querySelector('[data-atv-search-close]');
  const triggers = document.querySelectorAll('[data-atv-search-trigger]');
  const form = document.querySelector('[data-atv-search-form]');

  if (!overlay || !input || !resultsBox) return;

  let debounceTimer = null;
  let lastQuery = '';

  function openSearch(e) {
    if (e) e.preventDefault();
    overlay.classList.add('is-open');
    document.body.classList.add('atv-search-open');
    setTimeout(() => input.focus(), 60);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('atv-search-open');
    input.value = '';
    lastQuery = '';
    resultsBox.innerHTML = '';
  }

  triggers.forEach(t => t.addEventListener('click', openSearch));
  closeBtn && closeBtn.addEventListener('click', closeSearch);

  overlay.addEventListener('click', e => {
    if (e.target === overlay) closeSearch();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  // Soumission Entrée -> page /search?q=...
  form && form.addEventListener('submit', e => {
    e.preventDefault();
    const q = input.value.trim();
    if (q.length > 0) {
      window.location.href = '/search?q=' + encodeURIComponent(q);
    }
  });

  // Recherche live
  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(debounceTimer);
    if (q.length < 2) { resultsBox.innerHTML = ''; return; }
    debounceTimer = setTimeout(() => fetchResults(q), 220);
  });

  function fetchResults(q) {
    resultsBox.innerHTML = '<div class="atv-search__loading">Recherche en cours…</div>';
    const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=8&resources[options][unavailable_products]=last';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(data => {
        if (q !== lastQuery) return; // résultat obsolète
        renderResults(data.resources && data.resources.results, q);
      })
      .catch(() => {
        resultsBox.innerHTML = '<div class="atv-search__empty">Erreur de connexion — réessayez.</div>';
      });
  }

  function renderResults(results, q) {
    if (!results) {
      resultsBox.innerHTML = '<div class="atv-search__empty">Erreur de connexion.</div>';
      return;
    }
    const products = results.products || [];
    const collections = results.collections || [];
    const pages = results.pages || [];

    if (!products.length && !collections.length && !pages.length) {
      resultsBox.innerHTML =
        '<div class="atv-search__empty"><strong>Pas de résultat</strong>' +
        'Aucune pièce ne correspond à « ' + escapeHtml(q) + ' ». Essayez un autre mot.</div>';
      return;
    }

    let html = '<div class="atv-search__grid">';

    // Colonne produits
    if (products.length) {
      html += '<div><p class="atv-search__col-title">Pièces (' + products.length + ')</p><ul class="atv-search__list">';
      products.forEach(p => {
        const img = p.featured_image && p.featured_image.url
          ? '<img class="atv-search__thumb" src="' + p.featured_image.url + '" alt="" loading="lazy">'
          : '<div class="atv-search__no-thumb">ATV</div>';
        const price = p.price ? formatPrice(p.price) : '';
        html += '<li><a class="atv-search__product-link" href="' + p.url + '">'
          + img
          + '<div class="atv-search__product-info">'
          + '<span class="atv-search__product-title">' + escapeHtml(p.title) + '</span>'
          + (price ? '<div class="atv-search__product-price">' + price + '</div>' : '')
          + '</div></a></li>';
      });
      html += '</ul></div>';
    }

    // Colonne collections + pages
    if (collections.length || pages.length) {
      html += '<div>';
      if (collections.length) {
        html += '<p class="atv-search__col-title">Rayons</p><ul class="atv-search__list">';
        collections.forEach(c => {
          html += '<li><a class="atv-search__col-link" href="' + c.url + '">' + escapeHtml(c.title) + '</a></li>';
        });
        html += '</ul>';
      }
      if (pages.length) {
        html += '<p class="atv-search__col-title" style="margin-top:18px">Pages</p><ul class="atv-search__list">';
        pages.forEach(pg => {
          html += '<li><a class="atv-search__col-link" href="' + pg.url + '">' + escapeHtml(pg.title) + '</a></li>';
        });
        html += '</ul>';
      }
      html += '</div>';
    }

    html += '</div>';
    html += '<a class="atv-search__see-all" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a>';

    resultsBox.innerHTML = html;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  function formatPrice(cents) {
    // Shopify renvoie le prix en centimes (number) en suggest.json
    const n = typeof cents === 'number' ? cents / 100 : parseFloat(cents);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' €';
  }
})();
